import React, { useEffect } from 'react';
import clsx from 'clsx';
import { toast } from 'react-toastify';
import getCookie from '@/utils/cookies';
import isAnalyticsEnabled from '@/auth/featureToggles';
import AnalyticsConsentToast from './AnalyticsConsentToast';
import { trackingCookie } from '../constants';

const options = {
  hideProgressBar: true,
  position: 'bottom-center',
  draggable: false,
  autoClose: false,
  closeOnClick: false,
  closeButton: false,
  toastId: trackingCookie.TOAST_ID,
};

const CookieConsentLayout = ({ children, theme }) => {
  useEffect(() => {
    if (!isAnalyticsEnabled()) return;

    const analyticsCookie = getCookie(trackingCookie.NAME);

    if (analyticsCookie === undefined) {
      toast(<AnalyticsConsentToast />, options);
    }
  }, []);

  return (
    <div className={clsx('page rsh-content aridhia-layout-page no-ribbon-content', `aridhia-theme-${theme}`)} id="fair">
      <div className="tabs" id="main_content">
        {children}
      </div>
    </div>
  );
};

export default CookieConsentLayout;
